import * as React from 'react';
import * as svgs from './icons';

export const iconsMap = {
	// articleThumb: require('../../assets/icons/ArticleThumb.svg'),
	articleThumb: svgs.articleThumb,
	helpful: svgs.helpful,
	unhelpful: svgs.unhelpful,
	voteForExperience: svgs.voteForExperience,
	voteForFeature: svgs.voteForFeature,
	checkedCircle: svgs.checkedCircle,
	magnifier: svgs.magnifier,
	resolution110: svgs.collecting,
	resolution112: svgs.workingonit,
	resolution114: svgs.comingsoon,
	resolution116: svgs.solved,
	resolution120: svgs.collecting,
	resolution122: svgs.workingonit,
	resolution124: svgs.solved,
	home: svgs.home,
	contact: svgs.contact,
	kb: svgs.kb,
	back: svgs.back,
};

export interface IconProps {
	icon: string;
	className?: string;
}

export const Icon = (props: IconProps) => {
	const html = {__html: props.icon};
	const className = props.className ? ` ${props.className}` : '';
	return (
		<span className={`svg-icon${className}`} dangerouslySetInnerHTML={html}/>
	);
};
